import {
  getWappSession,
  WappRunnerEvent,
  listen as wappRunnerListen,
} from 'weblite-web-wapprunner'
import { eventSubscriptionEvent } from '@weblite-wapps/protocol'
import { extractGroupNameFromTopic } from './helpers'
import {
  unsubscribeWappSession,
  getWappSessionsSubscribedToTopic,
} from './service'
import { sendEventToWapp } from '$logic/wapp-communication/wapp-communication.publish'
import { serverSub } from '$func/subscription'

serverSub.subscribeToAll(action => {
  const { meta } = action
  if (!meta?.topic) return

  const { groupName, topic } = extractGroupNameFromTopic(meta.topic)
  const sessionIds = getWappSessionsSubscribedToTopic(groupName, topic)

  sessionIds.forEach(sessionId => {
    const session = getWappSession(sessionId)
    if (session)
      sendEventToWapp(eventSubscriptionEvent({ topic, action }, session))
  })
})

wappRunnerListen((e, sessionId) => {
  if (e === WappRunnerEvent.UNMOUNT && sessionId)
    unsubscribeWappSession(sessionId)
})
